import React, {useState, useEffect, useRef, useCallback, useContext} from 'react'
import styled from 'styled-components'
import {graphql, useStaticQuery} from 'gatsby'
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight'
import { navigate } from 'gatsby'

import {StateContext} from '../../utils/context'

import BlogSmallCategoryMenuMobile from '../../atoms/BlogSmallCategoryMenuMobile'

export default () => {
  const data = useStaticQuery(graphql`query { 
    allBlogCategories
    allMdx(filter: {frontmatter: {type: {eq: "blog"}, show: {eq: "show"}}}) {
      totalCount
    }
  }`)

  const [sticked, setSticked] = useState(false)
  const refCategoryLargeMenu = useRef()
  const context = useContext(StateContext)

  const setScrollSticky = useCallback(() => {
      const currentFromTop = refCategoryLargeMenu.current.getBoundingClientRect().top
      if (currentFromTop <= 70) setSticked(true)
      else setSticked(false)
  }, [])

  useEffect(() => {
    window.addEventListener('scroll', setScrollSticky)
    return () => {
      window.removeEventListener('scroll', setScrollSticky)
    }
  }, [setScrollSticky])

  const categories = JSON.parse(data.allBlogCategories)
  const {totalCount} = data.allMdx

  const handleClickLargeCategory = (e) => {
    if (e.target.id === 'all') navigate('/blogs', {state: {large: 'all', small: 'self'}})
    if (context.state.activeLargeCategory === e.target.id) return null
    context.dispatch({type: 'SelectLargeCategory', payload: {large: e.target.id, small: 'self'}})
  }
  
  return (
    <>
      <MenuContainer ref={refCategoryLargeMenu} className={sticked ? 'stick' : null}>
        <LargeCategory 
          key="all"
          className={context.state.activeLargeCategory === 'all' ? 'active' : null}
          id="all"
          onClick={handleClickLargeCategory}
        >
          All
          <LargeCount
            id="all"
            onClick={handleClickLargeCategory}
          >
            {`(${totalCount})`}
          </LargeCount>
        </LargeCategory>
        {Object.keys(categories).map(large => {
          return (
            <div key={large} >
              <LargeCategory
                className={context.state.activeLargeCategory === large ? 'active' : null}
                id={large}
                onClick={handleClickLargeCategory}
              >
                <ArrowIcon/>{large.toUpperCase()}
                <LargeCount
                  id={large}
                  onClick={handleClickLargeCategory}
                >
                  {`(${categories[large].self})`}
                </LargeCount>
              </LargeCategory>
              {!context.state.isMobile && context.state.activeLargeCategory === large ? <BlogSmallCategoryMenuMobile sticked={sticked} smallCategoryList={categories[context.state.activeLargeCategory]}/> : null}
            </div>
          )
        })}
      </MenuContainer>
      {context.state.isMobile ? <BlogSmallCategoryMenuMobile sticked={sticked} smallCategoryList={categories[context.state.activeLargeCategory]}/> : null}
    </>
  )
}

const MenuContainer = styled.div`
  background-color: ${props => props.theme.beige};
  width: 100%;
  margin: 0 auto;
  height: 3rem;
  overflow: scroll;
  scrollbar-width: none;
  white-space: nowrap;
  display: flex;
  align-items: center;
  padding-left: 2rem;
  padding-right: 2rem;
  position: sticky;
  top: 70px;
  z-index: 10;
  border: none;
  &::-webkit-scrollbar {
    display: none;
  }
  &.stick {
    background-color: rgba(0, 0, 0, 0.7);
    color: #fff;
    & div {
      color: #fff;
    }
  }
  @media(min-width: 900px) {
    position: sticky;
    flex-direction: column;
    width: 40%;
    height: calc(100vh - 3rem);
    align-items: flex-start;
    padding-top: 4rem;
    z-index: 0;
    margin: 0;
    padding-left: 1rem;
  }
  @media(min-width: 1300px) {
    padding-left: 2rem;
  }
`
const LargeCategory = styled.div`
  width: auto;
  color: ${props => props.theme.green};
  font-size: 1.3rem;
  display: flex;
  justify-content: center;
  align-items: baseline;
  font-weight: 300;
  transition: all 0.05s;
  cursor: pointer;
  &.active {
    font-weight: bold;
    font-size: 1.5rem;
  }
  @media(min-width: 900px) {
    font-size: 1.3rem;
    margin-bottom: 1rem;
    justify-content: flex-start;
    height: auto;
    &.active {
      svg {
        transform: rotate(90deg)
      }
    }
  }
  @media(min-width: 1300px) {
    font-size: 1.6rem;
  }
`
const LargeCount = styled.div`
  width: auto;
  color: ${props => props.theme.green};
  font-size: 1rem;
  margin-right: 1.5rem;
  cursor: pointer;
  &.active {
    font-weight: bold;
  }
  @media(min-width: 900px) {
    font-size: 1.1rem;
  }
`
const ArrowIcon = styled(KeyboardArrowRightIcon)`
  text-align: center;
  display: none !important;
  @media(min-width: 900px) {
    display: block !important;
  }
`